import { ref } from 'vue';

// Reactive state to track if auth has been checked
export const isAuthReady = ref<boolean>(false);

export function setAuthReady (ready: boolean) {
    isAuthReady.value = ready;
}
